// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vendor-ledger-inputs-wrapper{width:100%;padding:15px;display:flex;justify-content:space-between;align-items:center;background:#fff;border:0}.vendor-ledger-inputs-wrapper .vendor-ledger-inputs{display:flex;align-items:center}.vendor-ledger-inputs-wrapper .button-set-wrapper{background:#e9e9e9;border-radius:4px;padding:10px}\n", ""]);
// Exports
module.exports = exports;
